module.exports = __webpack_public_path__ + "static/img/12.83992ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/eng/12.png
// module id = pQym
// module chunks = 0